import { render } from "./navComponent.vue?vue&type=template&id=dcaa5aea&scoped=true"
import script from "./navComponent.vue?vue&type=script&lang=js"
export * from "./navComponent.vue?vue&type=script&lang=js"

import "./navComponent.vue?vue&type=style&index=0&id=dcaa5aea&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dcaa5aea"]])

export default __exports__